import { Grid, GridItem, TextButton, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import ApproveProposalButton from "../../components/ApproveProposalButton";
import { StepPage } from "../../components/StepPage";
import { TextBox } from "../../components/TextBox";
import BankSecurityRow from "../../../components/BankSecurityRow/BankSecurityRow";
import ManagePaymentMethods from "../../../components/ManagePaymentMethods/ManagePaymentMethods";
import { usePaymentMethodLearnMoreModal } from "../../../components/PaymentMethodLearnMoreModal/usePaymentMethodLearnMoreModal";
import { ErrorText } from "../../../constants";
import { useStore } from "../../../contexts";
import { relationshipModel } from "../../../models";
import { selectors } from "../../../store/state-selectors";
import { useResponsive } from "../../contexts";
import { COBStep, getStepName, isApproveProposalDisabled } from "../ClientOnboarding.utils";
import { useCobConfig } from "../CobConfigContext";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const {
  ConnectPaymentMethodStepTestIds
} = getTestIds();
export default function ConnectPaymentMethodStep(props) {
  const {
    isMemberClient = false,
    selectedPaymentId,
    disabledReason,
    approveAgreementStatus = null,
    previewStatus,
    onSelectPaymentMethod,
    onDone,
    onBack
  } = props;
  const {
    relationship
  } = useCobConfig();
  const isVendor = useStore(selectors.user.isVendor);
  const userId = useStore(selectors.user.id);
  const isPreview = !!previewStatus;
  const {
    isMobile,
    isDesktop
  } = useResponsive();
  const openLearnMoreModal = usePaymentMethodLearnMoreModal(isDesktop);
  const role = useStore(selectors.user.role);
  const disabled = isApproveProposalDisabled(disabledReason, isPreview, relationship, userId, role);
  return /*#__PURE__*/_jsx(StepPage, {
    header: getStepName(COBStep.paymentMethod, relationship),
    disabledReason: disabled ? disabledReason : undefined,
    errorMessage: approveAgreementStatus === 'error' ? ErrorText.UnexpectedErrorTryAgain : '',
    testId: ConnectPaymentMethodStepTestIds.Root(),
    primaryBtn: /*#__PURE__*/_jsx(ApproveProposalButton, {
      onDone: onDone,
      disabled: disabled || approveAgreementStatus === 'loading',
      testId: relationship.isSample || isPreview ? ConnectPaymentMethodStepTestIds.TestAgreementSubmitButton() : ConnectPaymentMethodStepTestIds.SubmitButton(),
      relationship: relationship,
      isDesktop: isDesktop,
      previewStatus: previewStatus
    }),
    onBackBtnClick: onBack,
    children: /*#__PURE__*/_jsxs(Grid, {
      children: [/*#__PURE__*/_jsx(GridItem, {
        children: /*#__PURE__*/_jsx(TextBox, {
          children: /*#__PURE__*/_jsxs(Typography, {
            children: ["Select a payment method to connect. You will only pay what is stated in the agreement.", ' ', /*#__PURE__*/_jsx(TextButton, {
              testId: ConnectPaymentMethodStepTestIds.LearnMoreButton(),
              onClick: openLearnMoreModal,
              children: "Learn more"
            })]
          })
        })
      }), /*#__PURE__*/_jsx(GridItem, {
        span: 12,
        children: /*#__PURE__*/_jsx(ManagePaymentMethods, {
          isProposal: true,
          vendorId: relationshipModel.vendor(relationship),
          customerId: relationshipModel.customer(relationship),
          showCreditCardFee: !relationshipModel.isVendorCoveringCCFee(relationship),
          isPreview: isPreview,
          isSample: relationshipModel.isSample(relationship),
          isMemberClient: isMemberClient,
          isInviteMemberDisabled: isVendor || relationshipModel.isSample(relationship) || isPreview,
          onSelectPaymentMethod: function (_onSelectPaymentMethod) {
            function onSelectPaymentMethod(_x) {
              return _onSelectPaymentMethod.apply(this, arguments);
            }
            onSelectPaymentMethod.toString = function () {
              return _onSelectPaymentMethod.toString();
            };
            return onSelectPaymentMethod;
          }(pm => {
            onSelectPaymentMethod(pm ? {
              id: pm.id,
              type: pm.type,
              last4: pm.last4,
              fundingSourceId: pm.id
            } : undefined);
          }),
          relationshipId: relationshipModel.id(relationship),
          initialSelectedPaymentMethodId: selectedPaymentId
        })
      }), /*#__PURE__*/_jsx(GridItem, {
        span: 12,
        children: /*#__PURE__*/_jsx(BankSecurityRow, {
          mobileView: isMobile
        })
      })]
    })
  });
}